const drawerWidth = 270;
const styles = theme => ({
  appBar: {
    position: 'fixed',
    backgroundColor: 'rgba(52, 118, 203, 1.0)',
    paddingTop:3,
    height: 63,
    boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 10px',
    marginLeft: drawerWidth,
    zIndex: 1000,
    [theme.breakpoints.up('sm')]: {
      height: 70,
      zIndex: 1000,
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      zIndex: 2000,
      width: '100%',
      height: 70,
      zIndex: 2000,
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Login/components/ApplicationBar/styles.js